import React from "react";
import { RecoverPassword } from "elentari";
import { resetPassword } from "../../services/Api";

export default function CustomRecoverPassword({ history, match }) {
  const handleSubmit = async ({ username }) => {
    const { token } = match.params;
    const response = await resetPassword({
      senha: username,
      token,
    });
    if (response.ok) {
      return Promise.resolve({
        ok: true,
        message: "Senha redefinida com sucesso!",
      });
    }
    return { ok: false, message: "Token inválido" };
  };

  return (
    <RecoverPassword
      history={history}
      fieldType="password"
      usernameLabel="Nova senha"
      backLabel="Ir para Login"
      submitLabel="Redefinir senha"
      onBackClick={() => history.push("/login")}
      onSubmit={handleSubmit}
    />
  );
}
